import React from 'react';

const recentBookingHeader = (props) => (
    <header className={`u-flex u-borderBottomNormal phone-mb-4`}>
        <div className={`u-cursorPointer phone-ml-0 pb-2 phone-f-fill u-phoneTextAlignCenter`} onClick={() => props.onToggleRecentBookingType(1)} style={{
            borderBottom: props.recentBookingType === 1 ? '2px solid #3E72F7' : '2px solid transparent'
        }}><span className={`u-fontSize13 u-textColoNormal`}>Recent Trips</span></div>
        <div className={`ml-16 phone-ml-0 u-cursorPointer pb-2 phone-f-fill u-phoneTextAlignCenter`} onClick={() => props.onToggleRecentBookingType(2)} style={{
            borderBottom: props.recentBookingType === 2 ? '2px solid #3E72F7' : '2px solid transparent'
        }}><span className={`u-fontSize13 u-textColoNormal`}>Upcoming Trips</span></div>
        <div className={`ml-16 phone-ml-0 u-cursorPointer pb-2 phone-f-fill u-phoneTextAlignCenter`} onClick={() => props.onToggleRecentBookingType(3)} style={{
            borderBottom: props.recentBookingType === 3 ? '2px solid #3E72F7' : '2px solid transparent'
        }}><span className={`u-fontSize13 u-textColoNormal`}>Past Trips</span></div>
    </header>
);

export default recentBookingHeader;


// WEBPACK FOOTER //
// ./src/components/RecentBooking/RecentBookingHeader/RecentBookingHeader.js